import withRsSlidableNavigationHandlers from '@Pages/RetroSynthesis/components/RsSlidable/HOCs/withSlidableNavigationHandlers';
import { PrevNavigation, NextNavigation } from './RsSlidableNavigationBothSidesBase';

export const PrevNavigationWithHandlers = withRsSlidableNavigationHandlers()(PrevNavigation);
export const NextNavigationWithHandlers = withRsSlidableNavigationHandlers()(NextNavigation);
